// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.bank-account-title[data-v-38432b96] {\n    background-color: #1d50a0;\n}\n.bank-account-header[data-v-38432b96] {\n    background-color: #1c4f9e;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n}\n.bank-account-body[data-v-38432b96] {\n    background-color: #cdccd8;\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n    color: black;\n    margin-top: 6px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
